import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { removeNullishFromShape } from "../../utilities/general";

const requestSchema = yup.object({
  method: yup.string().required(),
  answer: yup.string().nullable(),
  passcode: yup.string().nullable(),
  wpuId: yup.number().required(),
});

export function useSend2FaOtpMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(
      HTTP_ENDPOINTS.send2FaOtp(),
      removeNullishFromShape({
        method: req.method,
        answer: req.answer,
        passcode: !req.answer ? req.passcode : undefined,
        wpuId: req.wpuId,
      }),
    );
  }, options);
}
